import './Header.css';
import React, { Suspense } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useRef, useEffect } from 'react';
import { X, Menu, ChevronDown } from 'lucide-react';
import logo_rus from '../assets/logo_rus.png';
import logo_eng from '../assets/logo_eng.png';
import logo_esp from '../assets/logo_esp.png';
import logo_zh from '../assets/logo_zh.png';
import { useParams } from 'react-router-dom';
const LanguageSwitcher = React.lazy(() => import('./LanguageSwitcher'));


const BASE_ITEMS = [
  { type: 'link', label: 'Реестр готовых решений', path: 'registry' },
  { type: 'link', label: 'Обучение лучших практик', path: 'courses' },
  { type: 'link', label: 'Маркетплейс готовых решений', path: 'marketplace' },
  { type: 'link', label: 'Книга лучших практик', path: 'book' },
];

function ProductMenu() {
  const { lang } = useParams();        // <-- текущий язык из URL
  const currentLang = lang || 'ru';    // fallback

  const productItems = BASE_ITEMS.map(item => ({
    ...item,
    to: `/${currentLang}/${item.path}`, // <-- добавляем префикс
  }));

  return (
    <nav className='flex flex-col gap-3 p-1'>
      {productItems.map(item => (
        <Link key={item.to} to={item.to}>{item.label}</Link>
      ))}
    </nav>
  );
}


export default function Header() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);             // мобильное меню
  const [isProductOpen, setIsProductOpen] = useState(false); // дропдаун «О продуктах» (десктоп)
  const [isProductOpenMobile, setIsProductOpenMobile] = useState(false); // в сайдбаре

  const ddRef = useRef(null);

  // закрытие дропдауна при клике вне и по Esc
  useEffect(() => {
    const onDocClick = (e) => {
      if (ddRef.current && !ddRef.current.contains(e.target)) setIsProductOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') { setIsProductOpen(false); setIsOpen(false); } };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDocClick); document.removeEventListener('keydown', onKey); };
  }, []);

  const handleLogin = () => {
    navigate('/login');
    setIsOpen(false);
  };

  const logoMap = { ru: logo_rus, en: logo_eng, es: logo_esp, zh: logo_zh };
  const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
  const currentLogo = logoMap[lang] || logo_eng;


  const go = (to) => { navigate(to); setIsOpen(false); setIsProductOpen(false); };

  return (
    <header className="header" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <Link to="/" style={{height: '100%', position: 'relative', zIndex: '2000'}}>
        <img src={currentLogo} style={{ height: '100%', width: 'auto' }} alt="logo"/>
      </Link>

      <div className='flex'>
        {/* Десктопное меню */}
        <nav className="nav-desktop">
          <ul>
            <li>
              <button onClick={() => go('/about')} style={{ background: 'inherit', border: '0' }}>
                {t('$AboutUs')}
              </button>
            </li>

            {/* О ПРОДУКТАХ — дропдаун */}
            <li className="dropdown" ref={ddRef}>
              <button
                className="dropdown-trigger"
                aria-haspopup="menu"
                aria-expanded={isProductOpen}
                onClick={() => setIsProductOpen(v => !v)}
              >
                {t('$AboutProduct')}
                <ChevronDown size={16} />
              </button>

              {isProductOpen && (
                <div className="dropdown-menu" role="menu">
                  <ProductMenu />
                </div>
              )}
            </li>
          </ul>

          <div style={{ display: 'flex', flexDirection: 'row', gap: '16px', color: 'black' }}>
            <button onClick={handleLogin} style={{backgroundColor: 'black', color: 'white', padding: '8px 16px', borderRadius: '20px'}}>
              {t('$Login')}
            </button>
            <Suspense fallback={<div>Loading...</div>}>
              <LanguageSwitcher />
            </Suspense>
          </div>
        </nav>

        <button onClick={handleLogin} className='mobile-login'>{t('$Login')}</button>

        {/* Бургер для мобильных */}
        <button className="burger" onClick={() => setIsOpen(true)}>
          <Menu size={28} />
        </button>

        {/* Сайдбар */}
        {isOpen && (
          <div className={`sidebar ${isOpen ? 'open' : ''}`}>
            <button className="close-btn" onClick={() => setIsOpen(false)}>
              <X size={28} />
            </button>

            <ul className='text-left'>
              <li>
                <button
                  onClick={() => { go('/about'); }}
                  style={{ background: 'inherit', border: '0' }}
                >
                  {t('$AboutUs')}
                </button>
              </li>

              {/* О ПРОДУКТАХ — раскрывающийся список */}
              <li className="mobile-accordion">
                <button
                  className="mobile-accordion-trigger"
                  onClick={() => setIsProductOpenMobile(v => !v)}
                >
                  {t('$AboutProduct', 'О продуктах')}
                  <ChevronDown size={18} className={isProductOpenMobile ? 'rot-180' : ''}/>
                </button>
                {isProductOpenMobile && (
                  <ul className="mobile-submenu">
                    <ProductMenu />
                  </ul>
                )}
              </li>
            </ul>

            <div style={{ marginTop: 'auto', display: 'flex', color: 'black', flexDirection: 'column', gap: '8px', marginBottom: '64px', width: '100%' }}>
              <button onClick={handleLogin} className='mobile-login' style={{marginRight: 'auto'}}>{t('$Login')}</button>
              <Suspense fallback={<div>Loading...</div>}>
                <LanguageSwitcher className={'text-[20px] w-full text-black'}/>
              </Suspense>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
